
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogAuthorEN]",
      function () {
        return require("private-next-pages/[...blogAuthorEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogAuthorEN]"])
      });
    }
  